import { InputComponent } from "components/components/Component";
import { SimpleInputBaseDefinition, SimpleInputBaseComponent } from "components/input/baseInputDefinition";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import { LabelElement } from "components/components/label/labelElement";
import template from "./checkbox.hbs";
import "./checkbox.scss";
import { CheckboxInputElement } from "./checkboxElement";

export class CheckboxInput extends SimpleInputBaseComponent<CheckboxInputDefinition> implements InputComponent {

    public static readonly componentType: string = "checkboxInput";

    private element: CheckboxInputElement;

    constructor(schema: CheckboxInputDefinition) {
        super(schema);
    }

    //Override superclass method with own properties
    public setDefinition(schema: CheckboxInputDefinition) {
        if (schema.labelKey == null || schema.labelKey.length === 0) {
            this.definition.labelWidth = 0;
        } else {
            this.definition.labelWidth = this.definition.labelWidth ?? 6;
        }
        if (this.definition.emptyWidth == null) {
            this.definition.emptyWidth = 0;
        }
        if (this.definition.inputWidth == null) {
            this.definition.inputWidth = 16 - (this.definition.labelWidth || 0) - this.definition.emptyWidth;
        }
        this.definition.width = this.definition.width ?? 16;
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        ComponentActionHelper.register(this);
        return this.view;
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-checkbox-input");

        this.genericBindEvents(this.element, false);
    }

    public getValue(): boolean {
        return this.element.data;
    }

    public value(v: boolean) {
        if ((v == null) || ((v as unknown) === "")) {
            this.element.data = null;
        } else {
            this.element.data = v;
        }
    }

    public setReadOnly(ro: boolean) {
        this.element.input.disabled = ro;
    }

    public setRequired(required: boolean) {
        let elementLabel = this.view.querySelector("s6-input-label");
        if (elementLabel != null) {
            (elementLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }
}

export interface CheckboxInputDefinition extends SimpleInputBaseDefinition {
}
